import { IAccessToken } from '@/store/models/auth.model';
import { IAuthPasskey } from '@/features/dashboard-users/store/support-user.model';

import { IBaseAction, TAppError } from '@/store/types/base.state';

export enum Auth2FaActionTypes {
  CREATE_PASSKEY = 'AUTH2FA.CREATE_PASSKEY',
  CREATE_PASSKEY_SUCCESS = 'AUTH2FA.CREATE_PASSKEY_SUCCESS',
  CREATE_PASSKEY_FAIL = 'AUTH2FA.CREATE_PASSKEY_FAIL',
  GET_PASSKEY = 'AUTH2FA.GET_PASSKEY',
  GET_PASSKEY_SUCCESS = 'AUTH2FA.GET_PASSKEY_SUCCESS',
  GET_PASSKEY_FAIL = 'AUTH2FA.GET_PASSKEY_FAIL',
  DELETE_PASSKEY = 'AUTH2FA.DELETE_PASSKEY',
  DELETE_PASSKEY_SUCCESS = 'AUTH2FA.DELETE_PASSKEY_SUCCESS',
  DELETE_PASSKEY_FAIL = 'AUTH2FA.DELETE_PASSKEY_FAIL',
  AUTHENTICATE = 'AUTH2FA.AUTHENTICATE',
  AUTHENTICATE_SUCCESS = 'AUTH2FA.AUTHENTICATE_SUCCESS',
  AUTHENTICATE_FAIL = 'AUTH2FA.AUTHENTICATE_FAIL',
  GENERATE_CHALLENGE = 'AUTH2FA.GENERATE_CHALLENGE',
  GENERATE_CHALLENGE_SUCCESS = 'AUTH2FA.GENERATE_CHALLENGE_SUCCESS',
  GENERATE_CHALLENGE_FAIL = 'AUTH2FA.GENERATE_CHALLENGE_FAIL',
}

export interface ICreatePasskeyAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.CREATE_PASSKEY;
}

export interface ICreatePasskeySuccessAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.CREATE_PASSKEY_SUCCESS;
  passkey: IAuthPasskey;
}
export interface ICreatePasskeyFailAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.CREATE_PASSKEY_FAIL;
  error: TAppError;
}

export interface IGetPasskeyAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.GET_PASSKEY;
}

export interface IGetPasskeySuccessAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.GET_PASSKEY_SUCCESS;
  passkey: IAuthPasskey;
}
export interface IGetPasskeyFailAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.GET_PASSKEY_FAIL;
  error: TAppError;
}

export interface IDeletePasskeyAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.DELETE_PASSKEY;
  dashboardUserId: string;
}

export interface IDeletePasskeySuccessAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.DELETE_PASSKEY_SUCCESS;
  passkey: IAuthPasskey;
  dashboardUserId: string;
}
export interface IDeletePasskeyFailAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.DELETE_PASSKEY_FAIL;
  error: TAppError;
  dashboardUserId: string;
}

export interface I2FaAuthenticateAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.AUTHENTICATE;
}

export interface I2FaAuthenticateSuccessAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.AUTHENTICATE_SUCCESS;
  token: IAccessToken;
  credentials: string;
}
export interface I2FaAuthenticateFailAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.AUTHENTICATE_FAIL;
  error: TAppError;
}

export interface IGenerateChallengeAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.GENERATE_CHALLENGE;
}

export interface IGenerateChallengeSuccessAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.GENERATE_CHALLENGE_SUCCESS;
}
export interface IGenerateChallengeFailAction extends IBaseAction {
  type: typeof Auth2FaActionTypes.GENERATE_CHALLENGE_FAIL;
  error: TAppError;
}

export type T2FaAction =
  | ICreatePasskeyAction
  | ICreatePasskeySuccessAction
  | ICreatePasskeyFailAction
  | IGetPasskeyAction
  | IGetPasskeySuccessAction
  | IGetPasskeyFailAction
  | IDeletePasskeyAction
  | IDeletePasskeySuccessAction
  | IDeletePasskeyFailAction
  | I2FaAuthenticateAction
  | I2FaAuthenticateSuccessAction
  | I2FaAuthenticateFailAction
  | IGenerateChallengeAction
  | IGenerateChallengeSuccessAction
  | IGenerateChallengeFailAction;

export interface ISelectorsSCA {
  deletedWallets?: {};
  wallets?: {};
  scaWalletId?: string;
}
